define('gamebox/types', ['exports', './color', './vector2', './vector3', './rect'], function (exports, _color, _vector2, _vector3, _rect) {
  'use strict';

  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

  var _Color = _interopRequire(_color);

  var _Vector2 = _interopRequire(_vector2);

  var _Vector3 = _interopRequire(_vector3);

  var _Rect = _interopRequire(_rect);

  'use strict';

  var Types = {};

  Types.Color = _Color;
  Types.Vector2 = _Vector2;
  Types.Vector3 = _Vector3;
  Types.Rect = _Rect;

  exports['default'] = Types;
  exports.Color = _Color;
  exports.Vector2 = _Vector2;
  exports.Vector3 = _Vector3;
  exports.Rect = _Rect;
});